import React from "react";
import Show from "../../../utils/show.component";

export const TurnOnOffModalContent = (props) => {
  
    const advance = () => {
    
        window.scrollTo(0, 0);
        props.callSaveCardStatus(props.agreeNbr, props.cardType, props.IsActive, props.cardNumberLastFour);
        props.closeModal();
  };

  return (
    <div>
      <div className="bold" style={{fontSize: "18px" }}>Are you sure you want to turn your card {props.IsActive ? "off" : "on"}?</div>
      <div style={{ paddingTop: "15px", fontSize: "14px" }}>
      <Show condition={props.IsActive}>
        All transactions, except for recurring payments, will be denied while your card is turned off.
      </Show>
      <Show condition={!props.IsActive}>
        Reactivating your card can take up to 1 business day. If you need to use your card right away, contact us at 888-267-7200.
      </Show>
      </div>
      <button
        className="px-1 w-100 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          advance();
        }}
        data-e2e-id="proceed-card-update"
      >
        Yes
      </button>
      <button
        className="px-1 w-100 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          props.closeModal();
        }}
        data-e2e-id="cancel-card-update"
      >
        No
      </button>
      <div style={{ paddingTop: "20px", fontSize: "14px" }}>
      <Show condition={props.IsActive}>
        If you suspect fraud or if your card is permanently lost or stolen, please call us at:<br/>
        <div style={{width: "100%" }}>
          <div style={{textAlign: "left", width: "200px", margin: "0 auto", paddingTop: "10px" }}>
            Domestic: 877-445-0728 or<br/>
            International: 301-837-8443
          </div>
        </div>
      </Show>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/modal/turn-on-off-modal-content.component.js